import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Building, Unit } from '@shared/definitions/syndic';

/**
 * Abstract DI seam so the shared building-unit-select component can load
 * buildings/units without importing the syndic feature (which would invert the
 * layer direction — shared must never import pages). Implemented by
 * SyndicService and wired in app.config via `useExisting`.
 */
export interface BuildingUnitDataSource {
  buildings$(): Observable<Building[]>;
  units$(buildingId: string): Observable<Unit[]>;
}

export const BUILDING_UNIT_DATA_SOURCE = new InjectionToken<BuildingUnitDataSource>(
  'BUILDING_UNIT_DATA_SOURCE',
);
